import { useSyncExternalStore } from "react";
import { RetreatManager, type EngineSnapshot } from "@retreats/engine";

/**
 * useRetreat — React hook for subscribing to engine state via useSyncExternalStore.
 * Returns the current EngineSnapshot (status, elapsedSeconds, pendingSession, error).
 *
 * Usage:
 *   const { status, elapsedSeconds, pendingSession, error } = useRetreat();
 */
export function useRetreat(): EngineSnapshot {
  const manager = RetreatManager.get();
  return useSyncExternalStore(
    manager.subscribe.bind(manager),
    manager.getSnapshot.bind(manager),
  );
}
